import { use_slice_ui } from '@/hooks/store/use_slices';
import { G_IMAGE_OVERLAY__segments_disabled_to_opacity } from '../../nodes/node/fields/image/_overlays/G_IMAGE_OVERLAY__segments_disabled_to_opacity';
import { G_IMAGE_OVERLAY__segments_interactive } from '../../nodes/node/fields/image/_overlays/G_IMAGE_OVERLAY__segments_interactive';
import { G_IMAGE__master_component } from '../../nodes/node/fields/image/_views/G_IMAGE__master_component';
import { G_LAYOUT__image_edit_base } from '../_base/G_LAYOUT__image_edit_base';

export function G_LAYOUT__image_edit_segments() {
  /*
   * STORE
   */

  const { g_image_edit__field: field } = use_slice_ui(['g_image_edit__field']);

  /*
   * HTML
   */

  return (
    <G_LAYOUT__image_edit_base>
      <G_IMAGE__master_component {...{ field }}>
        <G_IMAGE_OVERLAY__segments_disabled_to_opacity field={field} />
        <G_IMAGE_OVERLAY__segments_interactive field={field} />
      </G_IMAGE__master_component>
    </G_LAYOUT__image_edit_base>
  );
}
